import './styles.scss'

import { Skeleton } from 'antd'

const DescriptionBox = ({
  categoryName = '',
  text = '',
  isLoading = false,
}) => (
  <div className="full-width-page-component__wrapper">
    <div className="sub-category-description-box__wrapper">
      <div className="sub-category-description-box__content-wrapper">
        {isLoading ? <Skeleton active /> : (
          <div className="fadeIn-0.6">
            <h1 className="sub-category-description-box__heading">
              {categoryName}
            </h1>
            <p className="sub-category-description-box__description">{text}</p>
          </div>
        )}
      </div>
    </div>
  </div>
)

export default DescriptionBox
